import { useIntl } from 'react-intl';
import { useState } from 'react';
import { Modal } from 'antd';

import { confirmLost } from 'services/ops-control';

import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as AlertCircleOutlined } from 'assets/bosta-icons/alert-circle-outlined.svg';

import './AuditHubIsLiableModal.less';

const AuditHubIsLiableModal = ({ close, title, delivery, ...rest }) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async () => {
    setIsLoading(true);

    try {
      const res = await confirmLost(delivery?._id, {
        liabilityOn: 'HUB'
      });
      notify(res.message, 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      setIsLoading(false);
      close();
    }
  };

  return (
    <Modal
      className="br-audit-hub-is-liable-modal"
      wrapClassName="br-audit-hub-is-liable-modal-wrapper"
      {...rest}
      footer={null}
      centered
      onCancel={close}
    >
      <div className="br-audit-hub-is-liable-modal-container">
        <div className="br-audit-hub-is-liable-modal-alert-triangle-container">
          <AlertCircleOutlined className="br-audit-hub-is-liable-modal-alert-triangle" />
        </div>
        <div className="br-audit-hub-is-liable-modal-content">
          <span className="heading1">
            {intl.formatMessage({
              id: 'ops_control.lost_orders.audit_hub_is_liable_modal.title'
            })}
          </span>
          <span className="body">
            {intl.formatMessage({
              id: 'ops_control.lost_orders.audit_hub_is_liable_modal.description'
            })}
          </span>
        </div>
        <div className="br-audit-hub-is-liable-modal__footer">
          <BRButton
            className={'br-audit-hub-is-liable-modal__cancel-button'}
            label={intl.formatMessage({ id: 'common.back' })}
            onClick={close}
          />
          <BRButton
            loading={isLoading}
            className={'br-audit-hub-is-liable-modal__confirm-button'}
            disabled={isLoading}
            type="destructive-primary"
            label={intl.formatMessage({
              id: 'ops_control.lost_orders.audit_hub_is_liable_modal.confirm'
            })}
            onClick={onFinish}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AuditHubIsLiableModal;
